/**
 * 测试登录页面 - 用于调试
 */

import React, { useState } from 'react';
import { Button, Input, Card, Space, Typography, Alert } from 'antd';

const { Title, Text } = Typography;

const TestLogin: React.FC = () => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('admin123456');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const handleTest = async () => {
    setLoading(true);
    setResult(null);

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'https://chanfana-openapi-template-dev.dianhong-apple.workers.dev';
      
      console.log('测试登录...');
      console.log('API URL:', API_URL);
      console.log('用户名:', username);
      console.log('密码:', password);

      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      
      console.log('响应状态:', response.status);
      console.log('响应数据:', data);

      setResult({
        status: response.status,
        success: data.success,
        data: data,
      });
    } catch (error: any) {
      console.error('请求错误:', error);
      setResult({
        error: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 50, maxWidth: 800, margin: '0 auto' }}>
      <Card>
        <Title level={3}>登录功能测试</Title>

        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <div>
            <Text>API URL:</Text>
            <div style={{ background: 'var(--admin-fill)', padding: 10, marginTop: 5 }}>
              {process.env.REACT_APP_API_URL || 'https://chanfana-openapi-template-dev.dianhong-apple.workers.dev'}
            </div>
          </div>

          <div>
            <Text>用户名:</Text>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="用户名"
            />
          </div>

          <div>
            <Text>密码:</Text>
            <Input.Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="密码"
            />
          </div>

          <Button
            type="primary"
            onClick={handleTest}
            loading={loading}
            block
            size="large"
          >
            测试登录
          </Button>

          {result && (
            <div>
              <Alert
                message={result.error ? '请求失败' : result.success ? '登录成功' : '登录失败'}
                type={result.error ? 'error' : result.success ? 'success' : 'error'}
                showIcon
              />
              <div style={{ marginTop: 16, background: 'var(--admin-fill)', padding: 16, borderRadius: 4 }}>
                <Text code>
                  <pre>{JSON.stringify(result, null, 2)}</pre>
                </Text>
              </div>
            </div>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default TestLogin;

